import { DEFAULT_OUTPUT_PRESET, getOutputPreset, type OutputPresetId } from '@/content/instagram'
import {
  DOCUMENT_VERSION,
  NodeKind,
  TransformKind,
  type Document,
  type CropParams,
  type NodeId,
  type SourceId,
} from '@/core/document/types'
import { createNodeId, createSourceId } from '@/core/document/ids'
import { DEFAULT_OUTPUT_BACKGROUND } from '@/core/document/output'
import { validateDocument } from '@/core/document/validate'
import { largestRectForRatio, type AspectRatio, type Rect } from '@/core/geometry'
import type { SourceImage } from '@/core/image'

export interface CreatedImageDocument {
  sources: ReadonlyMap<SourceId, SourceImage>
  document: Document
  rootId: NodeId
}

export function createDefaultCropParams(source: SourceImage, ratio: AspectRatio): CropParams {
  return { rect: largestRectForRatio(source, ratio) }
}

export function createImageDocument(
  source: SourceImage,
  presetId: OutputPresetId = DEFAULT_OUTPUT_PRESET,
  rect?: Rect,
): CreatedImageDocument {
  const sourceId = createSourceId()
  const rootId = createNodeId()
  const preset = getOutputPreset(presetId)
  const ratio = preset.ratio ?? { w: source.width, h: source.height }
  const sources = new Map([[sourceId, source]])
  const document: Document = {
    version: DOCUMENT_VERSION,
    output: { presetId, split: null, background: DEFAULT_OUTPUT_BACKGROUND },
    root: {
      id: rootId,
      kind: NodeKind.Image,
      sourceId,
      transforms: {
        [TransformKind.Crop]: rect ? { rect } : createDefaultCropParams(source, ratio),
      },
    },
  }
  validateDocument(document, sources)
  return { sources, document, rootId }
}
